import { createTheme } from "@commonlibs";
import { lightPalette, borderSm, borderMd } from "./palette/lightPalette";
import baseTheme from "./baseTheme";

const lightTheme = createTheme({
    ...baseTheme,
    palette: lightPalette,
} as never) as unknown as {
    border: { sm: string; md: string };
};

lightTheme.border = {
    sm: borderSm,
    md: borderMd,
};

export default lightTheme;
